
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pay-less",
      function () {
        return require("private-next-pages/pay-less.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pay-less"])
      });
    }
  